import React from 'react';
import Countdown from 'react-countdown';

type Props = {
  expire?: string | number | Date;
};

const GCountdown = ({ expire }: Props) => {
  return (
    <Countdown
      date={expire}
      renderer={({ hours, minutes, seconds, days, completed }) => {
        if (completed) return <></>;
        return (
          <ul className="product-countdown list-inline">
            <li>
              <span>{days}</span>
            </li>
            <li>
              <span>{hours}</span>
            </li>
            <li>
              <span>{minutes}</span>
            </li>
            <li>
              <span>{seconds}</span>
            </li>
          </ul>
        );
      }}
    />
  );
};

export default GCountdown;
